import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pages.NumPages > 1)?_c('div',{staticClass:"d-flex mt-4 flex-1",staticStyle:{"align-items":"flex-end"}},[_c(VSpacer),_c(VPagination,{attrs:{"color":"primary","value":_vm.id,"length":_vm.pages.NumPages},on:{"input":_vm.setPage,"change":_vm.setPage}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }